import { connect } from "react-redux";
import InsertElement from "./../../components/survey/insert";
import { addElementMlab } from "./../../redux/actions/surveyActions";
import { getAllUsers } from "./../../redux/actions/surveyActions";
const mapStateToProps = (state, ownProps) => {
	return {
		userAddList: state.survey.surveyManager.userElement,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addElementMlab: element => {
			dispatch(addElementMlab(element));
		},
		getAllUsers: () => {
			dispatch(getAllUsers());
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InsertElement);



// WEBPACK FOOTER //
// src/pages/survey/InsertElement.js